'use es6';

import keyMirror from 'react-utils/keyMirror';
export default Object.freeze(keyMirror({
  CONTENT: null,
  LOGIC: null,
  SELECTORS: null
}));